module.exports = __webpack_public_path__ + "static/media/4@3x.cb5956c4.png";